import { render, staticRenderFns } from "./vivaExamList.vue?vue&type=template&id=11df4cf5&"
import script from "./vivaExamList.vue?vue&type=script&lang=js&"
export * from "./vivaExamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports